import React from 'react';
import theme from '../../theme';
import styled from 'styled-components';

const SVG = styled.svg`
  height: 30px;
  width: 105px;
`;

const LogoSVG = (props) =>
  <SVG
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 582 165"
    style={{enableBackground: 'new 0 0 582 165'}}
  >
    <g id="Logo">
      <path id="Text" fill={props.color} d="M423.9,122.4c0-0.1,0-0.1,0-0.2L446.7,15l31.5-4.3l-10.2,48.2c6.4-4,12.2-6,17.5-6
				c15.8,0,24.2,10.7,25.1,32.1c9.8-1.9,20.8-13.2,32.9-33.9L575,47c0.6,13.4,1.1,24.6,1.7,33.5l2.6,34c0.3,3.3,0.4,7.7,0.4,13
				s-1.1,10.3-3.4,14.9c-6.3,13-17.6,19.4-34,19.4c-11.4,0-19.6-3.1-24.4-9.3c-3.5-4.5-5.2-10.3-5.2-17.4s1.3-12.6,4.5-16.4
				c2.4-2.8,3.4-3.4,4.7-4.3c-2.3,3.9-2.3,7-2.3,10.4c0.5,17,10,20,15.9,20c4.7,0,8.1-1.4,10.2-4.2s3.2-7.1,3.2-13s-0.3-11.6-1-17.1
				c-1.6-13.9-2.8-28.5-3.6-43.8c-9.8,14.9-21.1,24.5-33.7,28.8c-1.2,14.8-5.1,27.7-11.7,38.9c-6.6,11.2-15.3,19.1-26.4,23.7
				c-5.8,2.4-13.1,3.6-21.8,3.6s-15.5-2.4-20.5-7.2c-3.6-3.4-5.8-7.8-6.9-13.2c-0.2,0.5-0.5,1-0.8,1.4c-8.5,12.6-19.4,19-32.9,19
				c-12.7,0-19.7-6.8-21.1-20.3c-8.3,13.5-18.8,20.3-31.5,20.3c-6.4,0-11.8-2-16.2-6.1c-4.4-4-6.5-10.5-6.5-19.5c0-4,0.6-8.7,1.7-14
				l14.4-68.6h30.6l-15.3,72.7c-0.4,2.2-0.6,4.2-0.6,6.1c0,5.8,2.1,8.8,6.3,8.8c7.5,0,13.2-6.3,17-18.9l14.4-68.6h30.6l-15.3,72.7
				c-0.6,2.4-0.9,4.9-0.9,7.5c0,4.9,2.9,7.3,8.7,7.3C413.9,141.1,420.4,134.9,423.9,122.4z M283,42.8c6.4-3.7,9.6-10.3,9.6-19.8
				c0-2.8-1.1-5.6-3.4-8.6s-6.4-4.4-12.4-4.4c-6,0-10.8,1.6-14.3,4.9s-5.3,7.5-5.3,12.7s0.7,9.4,2.1,12.5
				c2.5,5.8,6.9,11.4,13.1,16.9l8.7,7.9c7.8,7,13.1,12.7,15.8,17.3c5.5,9.3,8.2,18.6,8.2,28.2c0,17.7-6.1,31.4-18.3,41.1
				c-11,8.8-24.9,13.3-41.7,13.3c-20.7,0-34.5-6.6-41.6-19.9c-2.4-4.7-3.6-10.1-3.6-16.3c0-11.2,3.2-19.9,9.6-26.2
				C216,96.1,223.1,93,231,93c7.9,0,13.6,2.4,17,7.2c1.3,1.8,2,4.1,2.2,6.9c-10.9,0-18.5,3.6-22.7,10.7c-1.5,2.6-2.3,5.5-2.3,8.7
				c0,6.1,1.8,11.1,5.4,15.1s8.8,6.1,15.7,6.1c6.9,0,12.6-2.5,17.2-7.4s6.9-11.2,6.9-18.8c0-7.6-1.1-13.8-3.2-18.7
				c-2.2-4.9-4.9-9.5-8.1-13.7c-3.3-4.2-6.8-8.3-10.5-12.2c-3.7-3.9-7.3-7.8-10.5-11.7c-7.6-9.2-11.4-18.1-11.4-26.8
				c0-11,4.7-20.1,14.2-27.4C250.4,3.6,262,0,275.9,0c17.1,0,28,5.2,32.5,15.7c1.2,2.8,1.9,6.7,1.9,11.8s-1.6,9.7-4.7,13.7
				s-7,6.1-11.7,6.1C289.2,47.3,285.6,45.8,283,42.8z M487.7,79.1c-2.3-7.2-6.5-10.9-11.3-10.9c-3.4,0-6.2,0.5-8.3,1.4
				c-2.1,0.9-3.5,1.8-4.1,2.5l-11.5,54.4c-0.4,1.8-0.6,3.5-0.6,4.9c0,6.6,3.7,9.9,11.1,9.9c6.2,0,12-5.9,17.5-17.8
				c3.4-7.9,6.2-20,7.3-26.6C488.7,90.4,489,82.8,487.7,79.1z"/>
      <g id="Icon" transform="translate(0.000000, 0.808824)">
        <path id="Combined-Shape" fill={props.color} d="M11.3,0h138.8c6.2,0,11.3,5.1,11.3,11.3v139.1c0,6.3-5.1,11.3-11.3,11.3H11.3
					c-6.2,0-11.3-5.1-11.3-11.3V11.3C0,5.1,5.1,0,11.3,0z M96.9,113.2c4.5,0,8.1-3.6,8.1-8.1c0-4.5-3.6-8.1-8.1-8.1H24.2
					c-4.5,0-8.1,3.6-8.1,8.1c0,4.5,3.6,8.1,8.1,8.1H96.9z M129.2,97.1c-4.5,0-8.1,3.6-8.1,8.1c0,4.5,3.6,8.1,8.1,8.1h8.1
					c4.5,0,8.1-3.6,8.1-8.1c0-4.5-3.6-8.1-8.1-8.1H129.2z M48.4,145.6c4.5,0,8.1-3.6,8.1-8.1s-3.6-8.1-8.1-8.1H24.2
					c-4.5,0-8.1,3.6-8.1,8.1s3.6,8.1,8.1,8.1H48.4z M137.2,129.4H80.7c-4.5,0-8.1,3.6-8.1,8.1s3.6,8.1,8.1,8.1h56.5
					c4.5,0,8.1-3.6,8.1-8.1S141.7,129.4,137.2,129.4z"/>
      </g>
    </g>
  </SVG>;

const Logo = (props) => <LogoSVG color={props.dark ? 'white' : theme.darkGray3}/>;

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo/index.js